import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

// Search cruises via Widgety API (all cruise lines)
export const searchCruises = createAsyncThunk("cruises/search", async (params = {}) => {
  const response = await api.get("/widgety/cruises/search", { params });
  return response.data;
});

// Fetch operators list (cruise lines + ships)
export const fetchOperators = createAsyncThunk("cruises/operators", async () => {
  const response = await api.get("/widgety/operators");
  return response.data;
});

// Fetch cruise detail (port visits + cabin types)
export const fetchCruiseDetail = createAsyncThunk("cruises/detail", async ({ ref, shipId }) => {
  const params = shipId ? { ship_id: shipId } : {};
  const response = await api.get(`/widgety/cruise/${ref}`, { params });
  return response.data;
});

// Fetch pricing from local CruiseCompare DB (if available)
export const fetchCruisePricing = createAsyncThunk("cruises/pricing", async (cruiseId) => {
  const response = await api.get(`/cruises/pricing/${cruiseId}`);
  return response.data;
});

// Fetch filters from local DB (legacy)
export const fetchFilters = createAsyncThunk("cruises/filters", async () => {
  const response = await api.get("/cruises/filters");
  return response.data;
});

const cruisesSlice = createSlice({
  name: "cruises",
  initialState: {
    list: [],
    total: 0,
    totalPages: 0,
    currentPage: 1,
    operators: [],
    operatorsStatus: "idle",
    cruiseDetail: null,
    detailStatus: "idle",
    filters: { cruiseLines: [], ships: [], regions: [] },
    currentCruise: null,
    cabinOptions: [],
    status: "idle",
    filtersStatus: "idle",
    pricingStatus: "idle",
    error: null,
  },
  reducers: {
    clearCabinOptions(state) {
      state.cabinOptions = [];
      state.currentCruise = null;
    },
    clearCruiseDetail(state) {
      state.cruiseDetail = null;
      state.detailStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      // Widgety cruise search
      .addCase(searchCruises.pending, (state) => { state.status = "loading"; })
      .addCase(searchCruises.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload.cruises;
        state.total = action.payload.total;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(searchCruises.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Operators
      .addCase(fetchOperators.pending, (state) => { state.operatorsStatus = "loading"; })
      .addCase(fetchOperators.fulfilled, (state, action) => {
        state.operatorsStatus = "succeeded";
        state.operators = action.payload.operators;
      })
      // Cruise detail
      .addCase(fetchCruiseDetail.pending, (state) => { state.detailStatus = "loading"; })
      .addCase(fetchCruiseDetail.fulfilled, (state, action) => {
        state.detailStatus = "succeeded";
        state.cruiseDetail = action.payload;
      })
      // Legacy filters
      .addCase(fetchFilters.pending, (state) => { state.filtersStatus = "loading"; })
      .addCase(fetchFilters.fulfilled, (state, action) => {
        state.filtersStatus = "succeeded";
        state.filters = action.payload;
      })
      // Legacy pricing
      .addCase(fetchCruisePricing.pending, (state) => { state.pricingStatus = "loading"; })
      .addCase(fetchCruisePricing.fulfilled, (state, action) => {
        state.pricingStatus = "succeeded";
        state.currentCruise = action.payload.cruise;
        state.cabinOptions = action.payload.cabinOptions;
      });
  },
});

export const { clearCabinOptions, clearCruiseDetail } = cruisesSlice.actions;
export default cruisesSlice.reducer;
